import React, { useEffect, useMemo, useState } from "react";
import {
  GoogleMap,
  HeatmapLayer,
  LoadScript,
} from "@react-google-maps/api";
import configuration from "../../config";

const containerStyle = {
  width: "100%",
  height: "100vh",
};

const center = {
  lat: 23.0225,
  lng: 72.5714,
};

const HeatmapMap = () => {
  const [heatmapPoints, setHeatmapPoints] = useState([]);

  useEffect(() => {
    configuration
      .getAPI({ url: "trip/heatmap" })
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.payload)) {
          const trips = data.payload;
          const points = [];

          trips.forEach((trip) => {
            const pick = trip.pick_up;
            if (isValidCoord(pick)) {
              points.push(
                new window.google.maps.LatLng(
                  parseFloat(pick.latitude),
                  parseFloat(pick.longitude)
                )
              );
            }

            // const lastDrop = trip.drop_off?.[trip.drop_off.length - 1];
            // if (isValidCoord(lastDrop)) {
            //   points.push(
            //     new window.google.maps.LatLng(
            //       parseFloat(lastDrop.latitude),
            //       parseFloat(lastDrop.longitude)
            //     )
            //   );
            // }
          });

          setHeatmapPoints(points);
        }
      })
      .catch((err) => {
        console.error("API error:", err);
      });
  }, []);

  const isValidCoord = (point) =>
    point &&
    !isNaN(parseFloat(point.latitude)) &&
    !isNaN(parseFloat(point.longitude));

  return (
    // <LoadScript
    //   googleMapsApiKey={configuration.webAPIKey}
    //   libraries={["visualization"]}
    // >
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
        {heatmapPoints.length > 0 && (
          <HeatmapLayer data={heatmapPoints} options={{ radius: 40, opacity: 0.6 }} />
        )}
      </GoogleMap>
    // </LoadScript>
  );
};

export default HeatmapMap;
